import { SET_CURRENT_TRIPS } from "./action_trips";

const INITIAL_STATE = {
    currentTrips: []
}

const tripsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURRENT_TRIPS:
            return {
                ...state,
                currentTrips: action.payload
            }
        default:
            return state;
    }
}

export default tripsReducer;
